<template>
  <div class="table">
    <div class="table-header">
      <div class="table-row">
        <div class="cell sort cell-xxlarge center" @click="setSorting('ref')">
          Name
          <BaseIcon
            v-if="sortingOn == 'ref'"
            :name="this.isAscending ? 'chevron-up' : 'chevron-down'"
            class="icon"
          />
        </div>
        <div class="cell cell-xlarge center">Steps</div>
        <div class="cell cell-xxlarge center">Linked Devices</div>
        <div class="cell cell-big">Last changed</div>
        <LoadAmountList
          v-if="hasAmountDropdown"
          :totalItems="totalItems"
          @selectedAmount="selectedAmount"
        />
      </div>
    </div>
    <div class="table-content">
      <div
        class="table-row"
        v-bind:class="{'active-line-padding': selectedFlow === flow}"
        v-for="(flow, index) in this.flows"
        :key="index"
        @click="selectRow(flow)"
      >
        <div class="cell cell-xxlarge center">{{flow.name}}</div>
        <div class="cell cell-xlarge center">{{flow.stepCount}}</div>
        <div
          class="cell cell-xxlarge center"
        >{{flow.linkedDevices ? flow.linkedDevices.length : '0'}}</div>
        <div class="cell cell-big">{{ flow.editDate | formatDateTime}}</div>
        <div class="cell" @click.stop="openMenu(index)">
          <BaseIcon name="ellipsis-h" class="icon grey" size="lg" />
        </div>
        <MoreTableActions
          v-if="isOptionOpen && openOptions == index"
          :locationMenu="index == 0 ? 'bottom' : 'top'"
          @deleteRow="deleteRow"
          v-click-outside="closeMenu"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import MoreTableActions from "@/components/base/MoreTableActions";
import LoadAmountList from "@/components/base/LoadAmountList";

export default {
  components: {
    BaseIcon,
    MoreTableActions,
    LoadAmountList
  },
  computed: {},
  props: {
    flows: {
      type: Array,
      required: true
    },
    hasAmountDropdown: {
      type: Boolean,
      default: true
    },
    totalItems: Number
  },
  mounted() {},
  data() {
    return {
      selectedFlow: null,
      sortingOn: "ref",
      isAscending: true,
      isOptionOpen: false,
      openOptions: ""
    };
  },
  methods: {
    selectedAmount(val) {
      this.$emit("selectedAmount", val);
    },
    selectRow(flow) {
      if (this.selectedFlow != flow) {
        this.isOptionOpen = false;
      }
      this.selectedFlow = flow;
      this.$emit("selectedRow", flow);
    },
    openMenu(index) {
      if (this.openOptions != index) {
        this.isOptionOpen = true;
      } else {
        this.isOptionOpen = !this.isOptionOpen;
      }
      this.openOptions = index;
    },
    closeMenu() {
      this.isOptionOpen = false;
      this.openOptions = "";
    },
    deleteRow() {
      var that = this;
      if (!this.selectedFlow.linkedDevices.length) {
        this.$http.delete(this.$endpoint + 'management/productionFlow/delete/' + this.selectedFlow.flowID)
        .then(response => {
          this.isOptionOpen = false
          this.openOptions = ''
          that.$emit('refresh', true);
          that.$swal(
            'Production Flow deleted!',
            `Your Production Flow has been successfully deleted.`,
            'success'
          );
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$store
            .dispatch("logout")
            .then(() => this.$router.push("/login"))
            .catch(err => console.log(err));
          } else {
            that.$swal(
              'Oops that went wrong?',
              `Please contact the admin with the following info: ${ error }`,
              'error'
            );
          }
        })
      } else {
        let flows = "";

        this.selectedFlow.linkedDevices.forEach(device => {
          flows += device.deviceRef + " - ";
        });
        flows = flows.substring(0, flows.length - 2);
        
        that.$swal(
          "delete conflict",
          `flow is still linked to a device, please revise: ${flows}`,
          "warning"
        );
      }
    },
    setSorting(val) {
      if (this.sortingOn != val) {
        this.isAscending = true;
      } else {
        this.isAscending = !this.isAscending;
      }
      this.sortingOn = val;

      this.$emit("sorting", { on: this.sortingOn, asc: this.isAscending });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../style/base.scss";
@import "../style/components/tables.scss";
@import "@/style/components/active.scss";

.table-header {
  .table-row {
    .cell.sort {
      cursor: pointer;
    }
  }
}
</style>
